/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createAsinh } from '../../factoriesAny.js';
export var asinhDependencies = {
  typedDependencies: typedDependencies,
  createAsinh: createAsinh
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesAsinh.generated.js
// module id = 1484
// module chunks = 0